module.exports = __webpack_public_path__ + "static/media/precision_desktop.d93e3583.jpg";